// File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.
import { APIResource } from "../../core/resource.mjs";
import * as RunsMessagesAPI from "./messages.mjs";
import { Messages } from "./messages.mjs";
import * as StepsAPI from "./steps.mjs";
import { Steps } from "./steps.mjs";
import * as TraceAPI from "./trace.mjs";
import { Trace } from "./trace.mjs";
import * as UsageAPI from "./usage.mjs";
import { Usage } from "./usage.mjs";
import { ArrayPage } from "../../core/pagination.mjs";
import { path } from "../../internal/utils/path.mjs";
export class Runs extends APIResource {
    constructor() {
        super(...arguments);
        this.messages = new RunsMessagesAPI.Messages(this._client);
        this.usage = new UsageAPI.Usage(this._client);
        this.steps = new StepsAPI.Steps(this._client);
        this.trace = new TraceAPI.Trace(this._client);
    }
    /**
     * Get the status of a run.
     */
    retrieve(runID, options) {
        return this._client.get(path `/v1/runs/${runID}`, options);
    }
    /**
     * List all runs.
     */
    list(query = {}, options) {
        return this._client.getAPIList('/v1/runs/', (ArrayPage), { query, ...options });
    }
}
Runs.Messages = Messages;
Runs.Usage = Usage;
Runs.Steps = Steps;
Runs.Trace = Trace;
//# sourceMappingURL=runs.mjs.map